import axios from "axios";
import {
  COUPON_VALIDATE_REQUEST,
  COUPON_VALIDATE_SUCCESS,
  COUPON_VALIDATE_FAIL,
  COUPON_CLEAR,
} from "../constants/couponConstants";

export const validateCoupon = (code) => async (dispatch, getState) => {
  try {
    dispatch({ type: COUPON_VALIDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const config = { headers: { Authorization: `Bearer ${userInfo.token}` } };
    const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/coupons/validate`, { code }, config);
    dispatch({ type: COUPON_VALIDATE_SUCCESS, payload: data.coupon });
  } catch (error) {
    dispatch({
      type: COUPON_VALIDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const clearCoupon = () => (dispatch) => {
  dispatch({ type: COUPON_CLEAR });
};
